module.exports = __webpack_public_path__ + "img/HHxemleklap2022.95ae4705.jpg";